

































import VueOptions from '@utils/VueOptions'
import SuperContainerView from '@superUI/Containers/SuperContainerView'
import UiList from '@superUI/List/List'

settings =
  name: "SuperUserList"
  components: { SuperContainerView, UiList }
  resources:
    superUsers:
      resourceName: "super_user"
      slug: "super_users"
      infinityScroll: true

  vue:
    data: ->
      searchValue: ''
      searchTimeout: null

    methods:
      hiFilterChange: ->
        @fetchInfinity(null, 'super_user', @combinedFilters(), { page: 1 })

      combinedFilters: ->
        q = @searchValue
        return { q }

      formatPermissionsFor: (item) ->
        { formatTitle } = @$options.filters
        permissions = []
        permissions.push(formatTitle(key)) for key of item.permissions when !!item.permissions[key]
        value = permissions.join ', ' if permissions.length
        value ||= '-'
        value

    watch:
      searchValue: (value) ->
        ctx = this
        window.stop()
        clearTimeout(@searchTimeout)
        @searchTimeout = setTimeout(() ->
          ctx.hiFilterChange()
        , 500)

export default VueOptions.vue settings
